import { resolveInitialLanguage } from 'features/language/languageConfig';

const NUMERIC_PATTERN = /^-?\d+([.,]\d+)?$/;

// Reads the app language, never navigator.language: middleware pins the backend's
// CurrentCulture to this same value, so writer and parser cannot drift apart.
const getServerDecimalSeparator = (): string => {
  const parts = new Intl.NumberFormat(resolveInitialLanguage()).formatToParts(
    1.1,
  );

  return parts.find((part) => part.type === 'decimal')?.value ?? '.';
};

export const normalizeAmountForServer = (
  value: string | number | undefined | null,
): string => {
  if (value === undefined || value === null || value === '') {
    return '';
  }

  const raw = String(value).trim();

  if (!NUMERIC_PATTERN.test(raw)) {
    return raw;
  }

  const separator = getServerDecimalSeparator();
  return raw.replace(/[.,]/, separator);
};
